import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";

import { ImageAttribution } from "../components/ImageAttribution";
import Instructions from "../components/Instructions";
import ComponentCard from "../components/Component";
import ComponentPreview from "../components/Preview";
import LeftColumnDiagram from "../components/cards/leftColumn/LeftColumn";
import ComponentStepLabel from "../components/StepLabel";

export default function AssessmentSummary(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
            margin-bottom: 1.5rem;
          }
        `}
      </style>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
        noInstructions
      />

      <ComponentCard
        title="Content"
        id="content"
        commentsCount={componentCommentsCount("content")}
      >
        {/* <ComponentPreview>
          <LeftColumnDiagram />
        </ComponentPreview> */}
        <ComponentStepLabel number="1" title="Image:" />
        <ImageAttribution attribution={data.media} tl={tl} dir={dir} />
        <ComponentStepLabel number="2" title="Text:" />
        <Paper
          elevation={0}
          variant="outlined"
          square
          className="px-16 pb-16 m-16"
        >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography className="text-14 font-bold">
                {course?.language?.title}:
              </Typography>
              <Divider className="my-8" />
            </Grid>
            <Grid item xs={12}>
              <Typography
                className={`${tl} m-0`}
                dir={dir}
                dangerouslySetInnerHTML={{ __html: data.tl_prefix }}
              />
              <Typography className="text-14 font-semibold mt-32">
                If learner passes:
              </Typography>
              <Typography
                className={`${tl} m-0`}
                dir={dir}
                dangerouslySetInnerHTML={{ __html: data.tl_passed }}
              />
              <Typography className="text-14 font-semibold mt-32">
                If learner fails:
              </Typography>
              <Typography
                className={`${tl} m-0`}
                dir={dir}
                dangerouslySetInnerHTML={{ __html: data.tl_failed }}
              />
            </Grid>
          </Grid>
        </Paper>

        <Paper
          elevation={0}
          variant="outlined"
          square
          className="px-16 pb-16 m-16"
        >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography className="text-14 font-bold">English:</Typography>
              <Divider className="my-8" />
            </Grid>
            <Grid item xs={12}>
              <Typography
                className="text-14 m-0"
                dangerouslySetInnerHTML={{ __html: data.en_prefix }}
              />
              <Typography className="text-14 font-semibold mt-32">
                If learner passes:
              </Typography>
              <Typography
                className="text-14 m-0"
                dangerouslySetInnerHTML={{ __html: data.en_prefix }}
              />
              <Typography className="text-14 font-semibold mt-32">
                If learner fails:
              </Typography>
              <Typography
                className="text-14 m-0"
                dangerouslySetInnerHTML={{ __html: data.en_failed }}
              />
            </Grid>
          </Grid>
        </Paper>
      </ComponentCard>
    </div>
  );
}
